import state from "./state";
import mutations from "./mutations";

const header = {
  namespaced: true,
  state,
  mutations,
};

export default header;
